import { render, staticRenderFns } from "./GroupSettingView.vue?vue&type=template&id=1a36877b&"
import script from "./GroupSettingView.vue?vue&type=script&lang=js&"
export * from "./GroupSettingView.vue?vue&type=script&lang=js&"
import style0 from "./GroupSettingView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports